import { css, html } from 'lit';

import { BaseAtomElement } from './base/BaseAtomElement.js';

/**
 *  Skeleton for header text element.
 *
 */
export class VeneerSkeletonHeader extends BaseAtomElement {
  static override properties = {
    /**
     * Sets the header block's height.
     */
    height: { type: String },
    /**
     * Sets the header block's width.
     */
    width: { type: String },
  };

  constructor() {
    super();
    this.height = '28px';
    this.width = '100%';
  }

  override render() {
    return html`<div
        class="vn-skel-loading__header"
        style="--vn-skeleton-header-height: ${this
          .height};--vn-skeleton-header-width: ${this.width};"
      ></div>
      <slot></slot>`;
  }

  static override styles = [
    ...super.styles,
    css`
      :host {
        --vn-skeleton-foreground-color: var(
          --vn-skeleton-effect-foreground-color__header
        );
        --vn-skeleton-background-color: var(
          --vn-skeleton-effect-background-color__header
        );
      }
      :host > div {
        width: var(--vn-skeleton-header-width, 100%);
        height: var(--vn-skeleton-header-height, 40px);
      }
      :host([theme-shape='round']) > div {
        border-radius: 4px;
      }
      :host([theme-shape='sharp']) > div {
        border-radius: 0px;
      }
      :host([theme-shape='pill']) > div {
        border-radius: 100vh;
      }
    `,
  ];
}

if (!customElements.get('veneer-skeleton-header')) {
  customElements.define('veneer-skeleton-header', VeneerSkeletonHeader);
}

declare global {
  interface HTMLElementTagNameMap {
    'veneer-skeleton-header': VeneerSkeletonHeader;
  }
}
